export { FollowedCompanies } from './FollowedCompanies';
